export const chartColors = [
  '#4b87b9',
  '#c06c84',
  '#f67280',
  '#f8b195',
  '#74b49b',
  '#00a8b5',
  '#494ca2',
  '#ffcd60',
  '#fff0db',
  '#eeeeee',
];

export const BACKEND_URL = 'https://console.getzingdata.com';

export const chartTypes = {
  BAR_CHART: 'BarChart',
  HORIZONTAL_BAR_CHART: 'HorizontalBarChart',
  STACKED_BAR_CHART: 'StackedBarChart',
  STACKED_BAR_100_CHART: 'StackedColumn100Chart',
  LINE_CHART: 'LineChart',
  STACKED_LINE_CHART: 'StackedLineChart',
  AREA_CHART: 'AreaChart',
  DONUT_CHART: 'DonutChart',
  DATA_TABLE: 'DataTable',
  BIG_NUMBER: 'BigNumber',
  SCATTER_PLOT: 'ScatterChart',
  COMBO_CHART: 'ComboChart',
};
